export default "__VITE_ASSET__CrgrQeF4__"